import { RouteObject } from "react-router-dom";
import DefaultLayout from "layout";
import PrestoSolarFlare from "view/presto_solar_flare";
import Aurora from "view/aurora";
import Forbush from "view/forbush";
import NotFoundPage from "view/404";

export interface IRouter {
  path: string;
  name: string;
  authentMenuName: string;
  exact: boolean;
  component: React.FC;
}

export const routers: RouteObject[] = [
  {
    path: "/",
    element: <DefaultLayout />,
    children: [
      {
        path: "/display/presto-solar-flare",
        element: <PrestoSolarFlare />,
      },
      {
        path: "/display/aurora",
        element: <Aurora />,
      },
      {
        path: "/display/forbush",
        element: <Forbush />,
      },
      {
        path: "/",
        element: <PrestoSolarFlare />,
      },
      {
        path: "*",
        element: <NotFoundPage />,
      },
    ],
  },
];
